import moment from 'moment-timezone'

export default ({ name, formikProps: { setFieldValue } }) => (date) => {
  setFieldValue('startDate', moment(date).startOf('week').toDate())
  setFieldValue('endDate', moment(date).endOf('week').toDate())
}
